import React from 'react';
import ButtonComponent from 'components/button/buttonComponent';
import RecommendedProductModal from './RecommendedProductModal';
import { useGetPage } from 'hooks/useGetPage';
import { pageIds } from 'utilities/constants';
import { UseRecommendedProductsOutput } from './useRecommendedProducts';
import { twMerge } from 'tailwind-merge';
import RecommendedProductCard from './RecommendedProductCard';

interface IRecommendedProductProps
  extends Omit<UseRecommendedProductsOutput, 'removeDraftRecommendation'> {
  patientFullName: string;
}

const RecommendedProducts: React.FC<IRecommendedProductProps> = ({
  patientFullName,
  selectedProducts,
  saveProducts,
  updateSelectedProducts,
  handleSaveProduct,
  handleCancelSaveProduct,
  handleDelete,
}) => {
  const [isModalOpen, setIsModalOpen] = React.useState(false);

  const { data: locale, loading: isLocaleLoading } = useGetPage({
    locale: 'en',
    pageId: pageIds.SHOP_DIAGNOSTIC,
  });

  if (isLocaleLoading) return null;

  return (
    <>
      <div className="bg-white desktop:p-30 p-5 flex flex-col gap-5 rounded-10">
        <div
          className={twMerge(
            'flex desktop:flex-row flex-col w-full desktop:justify-between desktop:items-center',
            !!saveProducts.length && 'border-b border-gray-opacity-15 pb-2.5',
          )}
        >
          <div className="text-neutral-800 font-semibold text-xl">
            {locale?.recommendedModalTitle}
          </div>
          <ButtonComponent
            type="underline"
            testID={'recommended'}
            className="text-sm !w-fit"
            onClick={() => setIsModalOpen(true)}
          >
            {locale?.recommended}
          </ButtonComponent>
        </div>

        <div
          className={twMerge(
            'flex flex-col gap-2.5',
            !saveProducts.length && 'hidden',
          )}
        >
          {saveProducts.map(({ title, amount, id }) => (
            <RecommendedProductCard
              title={title}
              amount={amount}
              onDelete={() => handleDelete(id)}
            />
          ))}
        </div>
      </div>

      <RecommendedProductModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        patientFullName={patientFullName}
        locale={locale}
        selectedProducts={selectedProducts}
        updateSelectedProducts={updateSelectedProducts}
        handleSaveProduct={handleSaveProduct}
        handleCancelSaveProduct={handleCancelSaveProduct}
      />
    </>
  );
};

export default RecommendedProducts;
